import { useCallback } from 'react'

export default function useUrlSearchValues(searchKey: string): [string, (string) => void] {
  const searchParams = new URLSearchParams(window.location.search)
  const searchValue = searchParams.get(searchKey)

  const setSearchValue = useCallback(
    (newValue) => {
      const url = new URL(window.location.href)
      url.searchParams.set(searchKey, newValue)

      window.history.replaceState(window.history.state, null, url)
    },
    [searchKey],
  )

  return [searchValue, setSearchValue]
}
